<template>
    <div>
        <gofix-card class="mb-0" fullContent>
            <gofix-default-table class=""
                :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableData"
                @new-item="openCreateModal"
                @row-click="clickToRowItem"
                @delete-items="deleteItems"
                ref="gofixTable">
                <template slot="gofix_table:created_at" slot-scope="row">
                    {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                </template>
                <template slot="gofix_table:remark" slot-scope="row">
                    <div v-if="checkIsJson(row.item.remark)">
                        <json-viewer
                            :value="row.item.remark | isJson"
                            :expand-depth="0"
                            sort></json-viewer>
                    </div>
                    <div v-else v-html="row.item.remark"></div>
                </template>
                <template slot="gofix_table:location" slot-scope="row">
                    <template v-if="row.item.user_location_id">
                        <b-button class="ml-2 p-0 bg-transparent border-0 goFixLocationButton" title="Geo Coordinates" v-b-tooltip.hover @click="showGeoLocation(row.item)">
                            <i class="icon-location-pin color-orange font-weight-bolder"></i>
                        </b-button>
                    </template>
                </template>
                <template slot="gofix_table:attachments" slot-scope="row">
                    <div v-if="row.item.attachments !== null && row.item.attachments.length > 0" class="attachmentsColumn" style="padding-left: 0;">
                        <div class="items">
                            <viewer-image :images="row.item.attachments" :showImage="false">
                                <template slot="gofixViewer:list_image" slot-scope="{images}">
                                    <div class="item" v-for="attachment in images">
                                        <div class="item-content position-relative" @click.stop="previewFile(attachment)">
                                            <span class="icon" v-html="$options.filters.iconFile(attachment, true)"></span>
                                            <span class="name">{{attachment.image_file_title || attachment.image_file_name}}</span>
                                            <!-- <img class="image-viewer" v-if="checkShowImage(attachment.image_content_type)" v-auth-image="attachment.url.original"  src="img/loading.gif"  :key="attachment.url.original"> -->
                                        </div>
                                    </div>
                                </template>
                            </viewer-image>
                        </div>
                    </div>
                    <template v-else>&nbsp;</template>
                </template>
                <template slot="gofix_table:completion_rate" slot-scope="row">
                    {{  row.item.completion_rate ? `${row.item.completion_rate}%` : ''  }}
                </template>
                <template slot="gofix_table:after-control-left" slot-scope="row" v-if="isShowDropdownLogType">
                    <gofix-form-dropdown
                        style="width:auto"
                        class="highlightDropdown ml-2 mr-3"
                        label=""
                        :clearable="false"
                        :searchable="false"
                        placeholder="Show"
                        :options="[
                            {label:'Main Activities', value: 'Manual'},
                            {label:'All Activities',value: null},
                        ]"
                        :reduce="option => option.value"
                        v-model="isFilterDrp">
                    </gofix-form-dropdown>
                </template>
            </gofix-default-table>
        </gofix-card>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.remark.title" hide-footer :centered="true" v-model="modals.remark.open" @hidden="hiddenModalRemark">
            <b-form class="formInvoice pb-10">
                <b-row>
                    <b-col md="12">
                        <gofix-form-input label="Remark" v-model="modals.remark.data.remark"></gofix-form-input>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="saveActivity" :loading="modals.remark.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.addRemark.title" hide-footer :centered="true" v-model="modals.addRemark.open" @hidden="hiddenModalRemark">
            <b-form class="formInvoice pb-10">
                <b-row>
                    <b-col md="12">
                        <gofix-form-input :required="true" :show-icon-required="true" label="Action" v-model="modals.addRemark.data.action"></gofix-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <gofix-form-input :required="true" :show-icon-required="true" label="Remark" v-model="modals.addRemark.data.remark"></gofix-form-input>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="createActivity" :loading="modals.addRemark.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!-- <b-modal :no-close-on-backdrop="false" id="modal-AddActivity" scrollable :title="modals.addActivity.title" hide-footer :centered="true" v-model="modals.addActivity.open" @hidden="hiddenModalRemark" size='lg'>
            <b-form class="formInvoice pb-11">
                <b-row>
                    <b-col md="12">
                        <gofix-form-input label="TO" v-model="modals.addActivity.data.to"></gofix-form-input>
                        <gofix-form-input label="CC" v-model="modals.addActivity.data.cc"></gofix-form-input>
                        <gofix-form-input label="Subject" v-model="modals.addActivity.data.subject"></gofix-form-input>
                        <gofix-form-input-texteditor  label="" content="" v-model="modals.addActivity.data.body"></gofix-form-input-texteditor>
                        <b-form-group label="Attachments" class="photosThumb clear-both">
                            <ul class="list-thumb" v-if="modals.addActivity.fileAttachments !== null">
                                <li v-for="(item,key) in modals.addActivity.fileAttachments" v-bind:key="key"> {{item.name}} <span class="delete" @click="deleteImgWorkFinding(item)"><img src="img/close.png" alt=""></span></li>
                            </ul>
                            <div class="upload-btn-wrapper"> -->
                                <!-- accept="image/jpeg, image/png, image/gif, .eml" -->
                                <!-- <b-form-file  id="fileInputMulti" v-model="modals.addActivity.fileAttachments" :plain="true" :multiple="true"></b-form-file>
                                <gofix-button class="m-3" label="file attachment" outline></gofix-button>
                            </div> 
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="Submit" @click="sendEmail" :loading="modals.addActivity.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal> -->
        <!-- Modal Geo Coordinates-->
        <b-modal
            id="modal-Remove"
            :title="modals.geo.title"
            :no-close-on-backdrop="true"
            dialog-class="modal-confirm-update"
            hide-footer
            :centered="true"
            v-model="modals.geo.open">
            <div class="py-3">
                <ul class="list-group">
                    <li class="list-group-item border-0 text-left">
                        <gofix-text-field label="Longitude:" classLabel="width-70" oneline>{{ modals.geo.data.longitude ? modals.geo.data.longitude : '--' }}</gofix-text-field>
                    </li>
                    <li class="list-group-item border-0 text-left">
                        <gofix-text-field label="Latitude:" classLabel="width-70" oneline>{{ modals.geo.data.latitude ? modals.geo.data.latitude : '--' }}</gofix-text-field>
                    </li>
                </ul>
            </div>
        </b-modal>
        <!-- Modal Add Case Manual -->
        <b-modal :no-close-on-backdrop="false" id="modal-Create" scrollable title="Create Activity" hide-footer :centered="true" v-model="modals.activityManual.open" size='lg'>
            <b-form class="formInvoice pb-11">
                <b-row align-v="center">
                    <b-col md="6">
                        <gofix-form-input-date
                            label="Action Date"
                            popoverDirection="top"
                            disabled
                            required
                            show-icon-required
                            v-model="modals.activityManual.data.date" >
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-time
                            label="Action Time"
                            popoverDirection="top"
                            disabled
                            required
                            show-icon-required
                            v-model="modals.activityManual.data.time" >
                        </gofix-form-input-time>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown
                                label="User"
                                desc="Search by email"
                                vLabel="user_name"
                                @search="searchUser"
                                :filterable="false"
                                :required="true"
                                :show-icon-required="true"
                                v-model="modals.activityManual.data.user"
                                :options="modals.activityManual.options.fmOfficer">
                            <template slot="gofixInput:dropdown:option"  slot-scope="option">
                                {{option.user_name}} - {{option.user_email}}
                            </template>
                            <template slot="gofixInput:dropdown:selected-option"  slot-scope="option">
                                {{option.user_name}} - {{option.user_email}}
                            </template>
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown
                            label="Action"
                            :clearable="false"
                            :show-icon-required="true"
                            vLabel="label"
                            v-model="modals.activityManual.data.action"
                            :required="true"
                            :options="[
                                {label:'Manual entry', value: 'Manual entry'}
                            ]">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12">
                        <!-- <gofix-form-dropdown
                            label="Completion rate"
                            :clearable="false"
                            :show-icon-required="true"
                            vLabel="label"
                            v-model="modals.activityManual.data.completion_rate"
                            :reduce="option => option.value"
                            :required="true"
                            :options="modals.activityManual.options.completion_rate">
                        </gofix-form-dropdown> -->
                        <gofix-form-input-number
                            label="Completion rate"
                            required
                            show-icon-required
                            :decimalLimit="0"
                            :allowDecimal="false"
                            :integerLimit="3"
                            desc="Please enter a number between 0 and 100"
                            @input="checkMaxValue"
                            v-model="modals.activityManual.data.completion_rate">
                        </gofix-form-input-number>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input-textarea required show-icon-required :rows="10" label="Status Update" v-model="modals.activityManual.data.remark"></gofix-form-input-textarea>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-row class="mb-3">
                            <div class="action actionFloat actionFloat__extra d-flex font-weight-bold">
                                <div class="title pl-15">Attachments</div>
                                <b-button @click="deleteAttachment" v-if="modals.activityManual.attachmentDeleteId.length">
                                    <div class="tooltip">Delete</div>
                                    <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                        <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                                    </svg>
                                </b-button>
                                <b-button type="button" @click="modals.attachment.open = true">
                                    <div class="tooltip">Create</div>
                                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                        <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                        <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                    </svg>
                                </b-button>
                            </div>
                        </b-row>
                        <b-row>
                            <b-col class="col-6 mb-3" v-for="(attachment,index) in modals.activityManual.attachments" :key="index">
                                <div class="attachmentInfo">
                                    <div class="checkbox">
                                        <b-form-checkbox class="uniform" :value="index" v-model="modals.activityManual.attachmentDeleteId"></b-form-checkbox>
                                    </div>
                                    <img v-if="checkShowIcon(attachment)" class="icon" :src="attachment | iconFile" with="24" height="24" alt="icon-file">
                                    <div class="name">{{attachment.image_file_title || attachment.image_file_name}}</div>
                                </div>
                            </b-col>
                            <b-col class="col-6 mb-3" v-for="(attachment,index) in modals.activityManual.attachment_tmp.add" :key="'tmp'+index">
                                <div class="attachmentInfo">
                                    <div class="checkbox">
                                        <b-form-checkbox class="uniform" :value="'tmp'+index" v-model="modals.activityManual.attachmentDeleteId"></b-form-checkbox>
                                    </div>
                                    <img v-if="checkShowIcon(attachment)" class="icon" :src="attachment | iconFile" with="24" height="24" alt="icon-file">
                                    <div class="name">{{attachment.image_file_title || attachment.name}}</div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="createActivityManual" :loading="modals.addActivity.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments" id="modal-Contract-Attachments" hide-footer v-model="modals.attachment.open">
            <b-form class="formV2">
                <gofix-form-input label="File Title" v-model="modals.attachment.image_file_title"></gofix-form-input>
                <b-form-group :label="modals.attachment.filename">
                    <b-form-file ref="file-input" v-model="modals.attachment.fileAttachment" ></b-form-file>
                </b-form-group>
                <b-button-group class="text-right d-block">
                    <gofix-button label="SUBMIT" @click="addAttachment" noBorder :loading="modals.attachment.loading"></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import JsonViewer from 'vue-json-viewer';
    import { filters } from '@/_filterVar.js';
    import { fileIcons } from "@/_commonVar.js";
    import moment from 'moment';
    import ViewerImage from '../plugins/ViewerImage.vue'
    export default {
        name: 'payment-voucher-info',
        props: {
            activityType: {
                type: String,
                default: null
            },
            activityId: {
                type: [String,Number],
                default: null
            },
            controls: {
                type: Object,
                default: () => {
                    return {
                        create: false,
                        delete: false,
                        update: true,
                    }
                }
            },
            isCaseActivity: {
                type: Boolean,
                default: false,
            },
            disableImport: {
                type: Boolean,
                default: false,
            },
            nameTable: {
                type: String,
                default: 'finance-activity-log'
            },
            isShowDropdownLogType: {
                type: Boolean,
                default: false,
            },
            item: {
                type: Object,
                default: () => {},
            },
            caseType: {
                type: String,
                default: null
            }
        },
        components: {
            JsonViewer,
            ViewerImage
        },
        data() {
            let filter =  JSON.parse(JSON.stringify(filters['activities']));
            return {
                modals:{
                    remark:{
                        open:false,
                        loading:false,
                        data:{
                            id:null,
                            remark: null
                        },
                        title: 'Add Remark'
                    },
                    addActivity:{
                        open:false,
                        loading:false,
                        data:{
                            id:null,
                            to: null,
                            cc:null,
                            subject:null,
                            body:"<h1>Some initial content</h1>",
                        },
                        title: 'New Email',
                        fileAttachments: null,
                    },
                    addRemark:{
                        open:false,
                        loading:false,
                        data:{
                            id:null,
                            action:null,
                            remark:null
                        },
                        title: 'Add Remark',
                    },
                    geo: {
                        open: false,
                        title: 'Geo Coordinates',
                        data: {
                            longitude: null,
                            latitude: null,
                        }
                    },
                    activityManual: {
                        open: false,
                        loading: false,
                        // title: 'Geo Coordinates',
                        data: {
                            date: null,
                            time: null,
                            user: null,
                            action: 'Manual entry',
                            log_type: 'Manual',
                            remark: null,
                            completion_rate: null
                        },
                        options: {
                            fmOfficer: [],
                            completion_rate: []
                        },
                        attachments: [],
                        attachmentUpdate: [],
                        attachmentDeleteId: [],
                        attachment_tmp: {
                            delete: [],
                            add:[],
                            update: []
                        },
                    },
                    attachment: {
                        open:false,
                        loading: false,
                        filename: "Click Browse to upload file",
                        fileAttachment:null,
                        image_file_title: '',
                        id: 0,
                        index: '',
                        edit: 0
                    },
                },
                tableConfig:{
                    name: this.nameTable,
                    controls:{
                        create: true,
                        delete: true,
                        // createTooptip: "New Email",
                        // renameField: this.isCaseActivity ? true : false,
                        tableImport: this.disableImport ? false : true,
                        tableExport: false,
                        update:true
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "created_at",
                    sortDirection: "desc",
                    fields: [
                        {
                            key: 'created_at',
                            label: 'Time Stamp',
                            isActive: 1,
                            isFilter: true,
                            with:150,
                            thStyle: "width:150px",
                            sorting: true,
                        }
                        ,{
                            key: 'action',
                            label: 'Activity',
                            thStyle: "width:180px",
                            isActive: 1,
                            isFilter: true,
                            with:150,
                            sorting: true,
                        },
                        {
                            key: 'actor_name',
                            label: 'User',
                            isActive: 1,
                            isFilter: true,
                            with:150,
                            thStyle: "width:150px",
                            sorting: true,
                        },
                        {
                            key: 'remark',
                            label: 'Remark',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            thStyle: "width:auto",
                            sorting: true,
                        },
                    ]
                },
                tableItems: [],
                isFilterDrp: 'Manual',
                timer: {
                    manual_entry: null
                }
            }
        },
        watch: {
            controls: function(val) {
                this.tableConfig.controls = Object.assign(this.tableConfig.controls, val);
            },
            isFilterDrp: function(val)  {
                this.$refs.gofixTable.reloadTableItems();
            },
            "modals.attachment.fileAttachment": function(val, old) {
                this.modals.attachment.filename = 'Click Browse to upload file';
                if (val) {
                    let extensionAccept = ['csv', 'pdf', 'txt', 'jpeg', 'jpg', 'png', 'gif','msg','html','htm','zip','eml'];
                    let extensionArray = val.name.split('.');
                    let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                    if(!extensionAccept.includes(extension)) {
                        this.$refs['file-input'].reset()
                        return this.$alertNotification("File format is incorrect. Please select a .zip, .html, .msg, .csv, .pdf, .txt, .jpeg, .jpg, .png, .gif, .eml file!", "warning");
                    }
                    this.modals.attachment.filename = val.name
                }
            },
            "modals.attachment.open": function(val) {
                if(val) this.resetFormImport();
            },
        },
        filters: {
            isJson(value) {
                try {
                    JSON.parse(value);
                } catch (e) {
                    return value;
                }
                return JSON.parse(value);
            },
            iconFile(val, is_svg = false) {
                const icons = fileIcons
                let path = 'img/';
                let type_show = 'img';
                let extension = '';
                let name = val.image_file_name || val.name;
                let type = val.type || val.image_content_type;

                if(is_svg) {
                    path = '';
                    type_show = 'svg';
                }
                if(val.type) extension = name.split('.')[1];

                let arrTemp = type.split('/');
                if(arrTemp && arrTemp.length == 2) {
                    let type = arrTemp[0];
                    if(!extension) extension = arrTemp[1];

                    if(type == 'application' || type == 'inode' || type == 'text') {
                        let key = 'pdf';
                        if(['docx', 'doc', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'msword'].includes(arrTemp[1])) key = 'word';
                        if(['xls', 'xlsx', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.ms-excel'].includes(arrTemp[1])) key = 'excel';
                        if(['zip', 'x-empty', 'plain'].includes(arrTemp[1])) {
                            let extension = name.split('.')[1];
                            if(['doc', 'docx'].includes(extension)) key = 'word';
                            if(['xls', 'xlsx', 'csv'].includes(extension)) key = 'excel';
                            if(['txt'].includes(extension)) key = 'text';
                        }
                        return `${path}${icons['application'][key][type_show]}`;
                    }

                    return `${path}${icons[type][type_show]}`;
                }
            }
        },
        computed: {
            ...mapGetters({
                IsReadOnly: 'OrderController/IsReadOnly',
                UserLogin : 'AuthController/user',
            }),
        },
        async created() {
           this.tableConfig.controls = Object.assign(this.tableConfig.controls, this.controls);
           //Check create log
           if(this.activityType == 'Work Order' && !this.IsReadOnly && this.$checkRole(this.$accessModule.wo_create_activity_log, 'wo_create_activity_log')){
                this.tableConfig.controls.create = true;
                this.tableConfig.controls.createTooptip = 'Create';
           }
        //    this.renameField();
        },
        methods: {
            renameField() {
                if(this.isCaseActivity) {
                    this.tableConfig.fields.forEach(item => {
                        if( item.key === 'created_at' ) {
                            item.label = 'Date & Time';
                        }
                        if (item.key === 'action') {
                            item.label = 'Action';
                        }
                    })
                }
            },
            /* ----Save data to email----------------------------------------------------*/
            sendEmail(){
                alert(this.modals.addActivity.data.to);
                console.log(this.modals.addActivity.fileAttachments);
                
            },
            /* ----Save data to remark----------------------------------------------------*/
            saveActivity(){
                this.modals.remark.loading = true;
                let params = {};

                let action = "create"
                let keyMessage= 'adding'
                if(this.modals.remark.data.id){
                    action = "update"
                    keyMessage = 'editing'
                    params = Object.assign({}, this.modals.remark.data);
                }else{
                    params = Object.assign({
                        work_item_type: this.activityType,
                        work_item_id: this.activityId,
                        action: "Remark"
                    }, this.modals.remark.data);
                }

                this.$store.dispatch(`ActivityLogsController/${action}`, params)
                    .then(response => {
                        this.modals.remark.loading = false;
                        this.modals.remark.open = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2(keyMessage, 'activity_log'));
                    })
                    .catch(err => {
                        this.modals.remark.loading = false;
                    })
            },
            async clickToRowItem(item){
                if(!this.controls.update) return;
                if(this.activityType == 'Case' && this.caseType && this.caseType == "Case Hot Button") return
                if(item.remark && !this.checkIsJson(item.remark)){
                    this.modals.remark.data.id = item.id;
                    this.modals.remark.data.remark = item.remark;
                    this.modals.remark.open = true;
                }

                
            },
            /* ---- Get data ----------------------------------------------------*/
            async getTableData(callback){
                


                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.work_item_id.value = this.activityId;
                tableRequest.filter.work_item_type.value = this.activityType;
                if(this.caseType && this.caseType == "Case Hot Button") {
                    if(this.isFilterDrp) tableRequest.filter.log_type.value = this.isFilterDrp;
                }
                if(this.activityType == 'Case') {
                    tableRequest.type = 'Case Normal';
                    if(this.caseType && this.caseType == "Case Hot Button") {
                        tableRequest.type = this.caseType;
                    }
                }
                await this.$store.dispatch("ActivityLogsController/get", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('ActivityLogsController/delete', ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'activity_log'))
                    })
                    .catch(err => {
                        reject();
                    })
            },
            triggerReloadData(){
                this.$refs.gofixTable.reloadTableItems();
            },

            /* ---- Attributes ----------------------------------------------------*/
            hiddenModalRemark(){
                this.modals.remark.data.id = null;
                this.modals.remark.data.remark = null;
                this.modals.remark.title = 'Add Remark';
            },
            checkIsJson(item){
                if(!item) return false;
                try {
                    let json_ = JSON.parse(item);
                    
                    if ( typeof(json_) == 'string' ) {
                        return false;
                    } else {
                        return true;
                    }
                } catch (e) {
                    return false;
                }
                return true;
            },
            openCreateModal(){
                if(this.activityType == 'Work Order' && this.$checkRole(this.$accessModule.wo_create_activity_log, 'wo_create_activity_log')){
                    this.modals.addRemark.open = true;
                    return;
                }
                // this.modals.addActivity.open = true;
                // if(!this.modals.activityManual.options.completion_rate.length) {
                //     for (let index = 0; index <= 100; index = index + 5) {
                //         this.modals.activityManual.options.completion_rate.push({
                //             label: `${index}%`,
                //             value: index === 0 ? '0' : index
                //         })
                //     }
                // }
                
                if(this.caseType && this.caseType == "Case Hot Button") {
                    this.getUsers();
                    this.modals.activityManual.data.date = moment().toDate();
                    this.modals.activityManual.data.time = moment().format("HH:mm");
                    this.modals.activityManual.data.user = {
                        user_id: this.UserLogin.id,
                        user_name: this.UserLogin.name,
                        user_email: this.UserLogin.email
                    };
                    this.modals.activityManual.data = Object.assign(this.modals.activityManual.data, {
                        action: 'Manual entry',
                        log_type: 'Manual',
                        remark: null,
                        completion_rate: null
                    })
                    this.modals.activityManual.attachments = this.modals.activityManual.attachmentUpdate = this.modals.activityManual.attachmentDeleteId = []
                    this.modals.activityManual.attachment_tmp.add = this.modals.activityManual.attachment_tmp.update = this.modals.activityManual.attachment_tmp.delete =[]
                    this.modals.activityManual.open = true
                }
            },
            createActivity(){
                if(!this.modals.addRemark.data.action || 
                    !this.modals.addRemark.data.remark){
                    return this.$alertNotification('Please enter all fields!', 'danger');
                }
                this.modals.addRemark.loading = true;
                let params = {};

                let action = "create"
                let keyMessage= 'adding'

                params = Object.assign({
                    work_item_type: this.activityType,
                    work_item_id: this.activityId,
                }, this.modals.addRemark.data);

                this.$store.dispatch(`ActivityLogsController/${action}`, params)
                    .then(response => {
                        this.modals.addRemark.loading = false;
                        this.modals.addRemark.open = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2(keyMessage, 'activity_log'));
                    })
                    .catch(err => {
                        this.modals.addRemark.loading = false;
                    })
            },
            showGeoLocation(item) {
                if(!item || !item.user_location_id) return
                this.$store.dispatch("JobController/getUserLocationJob", {
                    limit: 1,
                    showRelationship: '1',
                    filter: {
                        id: item.user_location_id
                    }
                })
                .then(response => {
                    if(response.items && response.items.length) {
                        const data = response.items[0];
                        this.modals.geo.data.longitude = data.longitude
                        this.modals.geo.data.latitude   = data.latitude
                        this.modals.geo.open = true
                    }
                });
            },
            // Add Activity 
            async getUsers(){
                let filter = {
                    user_name:{type:"text",value:"",function:"ilike",with:[]},
                    user_email:{type:"text",value:"",function:"ilike",with:[]},
                    user_type:{type:"text",value:"FM Officer",function:"ilike",with:[]},
                    service_category_name:{type:"text",value:"Hot button",function:"ilike",with:[]},
                    contract_id:{type:"number",value:this.item && this.item.client_contract_id ? this.item.client_contract_id : null,function:"=",with:[]}
                };
                let request = {
                    limit: 100,
                    page: 1,
                    isCMS:1,
                    sortColumn:'user_id',
                    sortDirection:'ASC',
                    filter: filter,
                    useDatabaseView:true
                };
                this.$store.dispatch("UserDutyController/getItems", request)
                    .then(result=>{
                        this.modals.activityManual.options.fmOfficer = result.items;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            async searchUser (search, loading){
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                let filter = {
                    user_name:{type:"text",value:'',function:"ilike",with:[]},
                    user_email:{type:"text",value:search,function:"ilike",with:[]},
                    user_type:{type:"text",value:"FM Officer",function:"ilike",with:[]},
                    service_category_name:{type:"text",value:"Hot button",function:"ilike",with:[]},
                    contract_id:{type:"number",value:this.item && this.item.client_contract_id ? this.item.client_contract_id : null,function:"=",with:[]}
                };
                let request = {
                    limit: 100,
                    page: 1,
                    isCMS:1,
                    sortColumn:'user_id',
                    sortDirection:'ASC',
                    filter: filter,
                    useDatabaseView:true
                };
                this.timer = setTimeout(() => {
                    this.$store.dispatch("UserDutyController/getItems", request)
                        .then(response => {
                            this.modals.activityManual.options.fmOfficer = response.items;
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
            },
            checkShowIcon(val) {
                if(!val) return false;
                let type = val.type || val.image_content_type;
                if(!type) return false;
                let arrTemp = type.split('/');
                if(!arrTemp || arrTemp.length < 2 || !fileIcons[arrTemp[0]]) return false;
                return true;
            },
            deleteAttachment(){
                if(this.modals.activityManual.attachmentDeleteId.length > 0){
                    this.modals.activityManual.attachmentDeleteId = this.modals.activityManual.attachmentDeleteId.sort().reverse();
                    for(let index of this.modals.activityManual.attachmentDeleteId){
                        if( typeof(index) == "string" && index.includes("tmp")) {
                            index = index.slice(3);
                            this.modals.activityManual.attachment_tmp.add.splice(index, 1);
                        }else {
                            let item = this.modals.activityManual.attachments.splice(index, 1);
                            this.modals.activityManual.attachment_tmp.delete.push(item[0])
                        }
                    }
                    this.modals.activityManual.attachmentDeleteId.length = 0;
                }
            },
            addAttachment(){
                if( this.modals.attachment.filename == 'Click Browse to upload file' && !this.modals.attachment.fileAttachment ) {
                    return this.$alertNotification("Please select a file", "danger");
                }

                if(this.modals.attachment.index !== '') {
                    if(this.modals.attachment.id != 0) {
                        if(this.modals.activityManual.attachments[this.modals.attachment.index]) {
                            this.modals.activityManual.attachments[this.modals.attachment.index].image_file_title = this.modals.attachment.image_file_title
                            this.modals.activityManual.attachments[this.modals.attachment.index].image_file_name = this.modals.attachment.fileAttachment ? this.modals.attachment.fileAttachment.name : this.modals.remark.attachments[this.modals.attachment.index].image_file_name
                            let index = this.modals.activityManual.attachment_tmp.update.findIndex(item => item.id == this.modals.attachment.id)
                            if(index != -1) {
                                this.modals.activityManual.attachment_tmp.update[index] = Object.assign(this.modals.activityManual.attachment_tmp.update[index], {
                                    image_file_title: this.modals.attachment.image_file_title,
                                    attachment: this.modals.attachment.fileAttachment || this.modals.activityManual.attachment_tmp.update[index].attachment
                                })
                            } else {
                                this.modals.activityManual.attachment_tmp.update.push({
                                    id: this.modals.attachment.id,
                                    image_file_title: this.modals.attachment.image_file_title,
                                    attachment: this.modals.attachment.fileAttachment
                                })
                            }
                        }
                    } else {
                        let idx = this.modals.attachment.index.slice(3);
                        if(this.modals.activityManual.attachment_tmp.add[idx]) {
                            this.modals.activityManual.attachment_tmp.add[idx] = this.modals.activityManual.attachment_tmp.add[idx] || this.modals.attachment.fileAttachment;
                            this.modals.activityManual.attachment_tmp.add[idx].image_file_title = this.modals.attachment.image_file_title
                        }
                    }
                    this.$refs['modal-Import-attachments-edit'].hide();
                } else {
                    //Add attachment
                    this.modals.attachment.fileAttachment.image_file_title = this.modals.attachment.image_file_title;
                    this.modals.activityManual.attachment_tmp.add.push(this.modals.attachment.fileAttachment);
                }
                this.resetFormImport();
                this.modals.attachment.open = false;
            },
            resetFormImport() {
                this.modals.attachment.filename = 'Click Browse to upload file';
                this.modals.attachment.fileAttachment = null;
                this.modals.attachment.image_file_title = null;
                this.modals.attachment.id = 0;
                this.modals.attachment.index = '';
            },
            async previewFile(attachment) {
                if(attachment.image_content_type && 
                   (attachment.image_content_type.includes('image') ||
                    attachment.image_content_type.includes('pdf')
                )
                ){
                    const link = document.createElement('a');
                    var path = this.$router.resolve({name: 'FilePreview', params: {file_id: attachment.id}}).href;
                    link.href= path;
                    link.setAttribute('target', '_blank');
                    document.body.appendChild(link);
                    link.click();
                }
                else{
                    await this.downloadAttachment(attachment);
                }
            },
            async downloadAttachment(item){
                let url = item.url.original;
                let params = {};
                params.url = url;
                params.image_file_name = item.image_file_name;

                await this.$store.dispatch("FileDownloadController/getFile", params)
                .then(response => {})
                .catch(err => {
                    this.$alertNotification("Can not download file", "danger");
                    console.log(err);
                });
            
                return this.$alertNotification("Download attachment successfully!");
                
            },
            createActivityManual(){
                if (this.timer.manual_entry) {
                    clearTimeout(this.timer.manual_entry);
                    this.timer.manual_entry = null;
                }
                this.timer.manual_entry = setTimeout(() => {
                    if(!this.modals.activityManual.data.date || !this.modals.activityManual.data.time || !this.modals.activityManual.data.user || 
                        !this.modals.activityManual.data.action || (this.modals.activityManual.data.completion_rate === null || this.modals.activityManual.data.completion_rate === '')  || !this.modals.activityManual.data.remark){
                        return this.$alertNotification('Please enter all fields!', 'danger');
                    }
                    this.modals.activityManual.loading = true;
                    let params = {};

                    let action = "createLogWithAttachment"
                    let keyMessage= 'adding'

                    const completion_rate = parseFloat(this.modals.activityManual.data.completion_rate.replace(/,/g, ''));

                    params = {
                        work_item_type: this.activityType,
                        work_item_id: this.activityId,
                        log_type: this.modals.activityManual.data.log_type,
                        remark: this.modals.activityManual.data.remark,
                        actor_id: this.modals.activityManual.data.user.user_id,
                        actor: this.modals.activityManual.data.user.user_name,
                        action: this.modals.activityManual.data.action,
                        completion_rate: completion_rate.toString(),
                        photos: this.modals.activityManual.attachment_tmp.add,
                        type: 'Case Hot Button',
                    };

                    this.$store.dispatch(`ActivityLogsController/${action}`, params)
                        .then(response => {
                            this.modals.activityManual.loading = false;
                            this.modals.activityManual.open = false;
                            this.$refs.gofixTable.reloadTableKeepFilter();
                            this.$alertNotification(this.$notificationV2(keyMessage, 'activity_log'));
                            if(Number(params.completion_rate) == 100) {
                                this.$emit('reloadCase')
                            }
                        })
                        .catch(err => {
                            this.modals.activityManual.loading = false;
                        })
                }, 300);
            },
            checkMaxValue() {
                let maxValue = 100
                const numericValue = parseFloat(this.modals.activityManual.data.completion_rate.replace(/,/g, ''));
                if (numericValue > maxValue) {
                    this.modals.activityManual.data.completion_rate = maxValue.toString();
                }
            },
        }
    }
</script>
